<div class="info-sheet" [class.is-no-product]="isNoProduct">
  @if (isNoProduct) {
  <div class="info-container">
    <span class="icon-wrap">
      <ion-icon name="alert-circle-outline" class="icon" aria-hidden="true" />
    </span>

    <h3 class="title">{{ "venta-rapida.info.no-product.title" | translate }}</h3>

    <p class="description">{{ "venta-rapida.info.no-product.description" | translate }}</p>
  </div>
  } @else {
  <div class="help-container">
    <h3 class="help-title">{{ "venta-rapida.info.help.title" | translate }}</h3>

    <p class="description">{{ "venta-rapida.info.help.description" | translate }}</p>

    <p class="help-alert">
      <ion-icon name="alert-circle-outline" aria-hidden="true" />
      <span>
        <strong>{{ "venta-rapida.info.no-product.title" | translate }}.</strong>
        {{ "venta-rapida.info.help.alert" | translate }}
      </span>
    </p>

    <ol class="help-steps">
      @for (stepKey of helpStepKeys; track stepKey; let i = $index) {
      <li>
        <span class="step-number" aria-hidden="true">{{ i + 1 }}</span>
        <span>{{ stepKey | translate }}</span>
      </li>
      }
    </ol>
  </div>
  }

  <div class="info-actions">
    <app-main-button [label]="'venta-rapida.info.close'" (clicked)="close()" />
    @if (isNoProduct) {
    <app-secondary-button [label]="'venta-rapida.info.how-it-works'" (clicked)="openHelp()" />
    }
  </div>
</div>
